import { SxStyle } from '@aibees/shared/theme';

export const content: SxStyle = {
  paddingX: 4,
  '.MuiFormHelperText-root': {
    marginTop: 0,
    paddingX: 3,
  },
};

export const checkbox: SxStyle = {
  '.MuiFormControlLabel-label': {
    fontSize: (p) => p.typography.body2,
  },
  '.MuiFormControlLabel-asterisk': {
    color: (p) => p.palette.error[500],
  },
};
